module.exports = __webpack_public_path__ + "img/dripbockie.6036463c.jpeg";